import { render, staticRenderFns } from "./MetaInfo.vue?vue&type=template&id=5b477b7e&scoped=true&"
import script from "./MetaInfo.vue?vue&type=script&lang=js&"
export * from "./MetaInfo.vue?vue&type=script&lang=js&"
import style0 from "./MetaInfo.vue?vue&type=style&index=0&id=5b477b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b477b7e",
  null
  
)

export default component.exports